import React, { useState, useEffect, useRef } from "react";
import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import { Eye, EyeClosed, CircleHelp } from "lucide-react";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const ChangePassword = ({ isVisible, setIsVisible }) => {
    const [vecchiaPassword, setVecchiaPassword] = useState("");
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [confermaPassword, setConfermaPassword] = useState("");
    const [isVecchiaPasswordVisible, setIsVecchiaPasswordVisible] = useState(false);
    const [isNuovaPasswordVisible, setIsNuovaPasswordVisible] = useState(false);
    const [isConfermaPasswordVisible, setIsConfermaPasswordVisible] = useState(false);
    const inputRefs = useRef([]);


    const closeModal = () => {
        setIsVisible(false);
    };

    const handleConferma = async () => {
        //Contollo la vechia password
        try {
            isLoading = true;
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: infoUtente["Email"], Password: vecchiaPassword, CodiceDispositivo: "ignore" }),
            });
            const data = await response.json();
            if (response.status === 401) {
                alert(data['error']);
                setVecchiaPassword('');
                return;
            }
            isLoading = false;
        } catch (error) {
            alert("Errore nell'operazione");
            console.log(error);
            return;
        }

        //Controllo che la nuova password rispetti i requisiti
        if (!checkPassword(nuovaPassword)) {
            alert('La nuova password non rispetta i requisiti');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (nuovaPassword !== confermaPassword) {
            alert('Le password non coincidono');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Confermo
        try {
            isLoading = true;
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente["ID"], Password: nuovaPassword }),
            });


            if (response.status === 200) {
                isLoading = false;
                closeModal();
            }
            else {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
            }
        } catch (error) {
            alert("Errore nell'operazione");
            console.log(error);
            return;
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div>
            <div className="mt-4">
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start">Vecchia password: </p>
                    <div className="relative flex items-center">
                        <input
                            type={isVecchiaPasswordVisible ? "text" : "password"}
                            placeholder=""
                            value={vecchiaPassword}
                            onChange={(e) => setVecchiaPassword(e.target.value)}
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 flex-1"
                            onKeyDown={(e) => handleKeyDown(e, 0)}
                            ref={(el) => (inputRefs.current[0] = el)}
                        />
                        <button
                            type="button"
                            onClick={() => setIsVecchiaPasswordVisible(!isVecchiaPasswordVisible)}
                            className="absolute right-2 text-black dark:text-white"
                        >
                            {isVecchiaPasswordVisible ? (
                                <EyeClosed size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </div>
                </div>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start flex items-center">Nuova password:
                        <button
                            type="button"
                            className="text-blue-500 ml-2"
                            onClick={() => alert('La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale (es. [!@#$%^&*(),.?":{}|<>])')}
                        >
                            <CircleHelp size={20} />
                        </button>
                    </p>
                    <div className="relative flex items-center">
                        <input
                            type={isNuovaPasswordVisible ? "text" : "password"}
                            placeholder=""
                            value={nuovaPassword}
                            onChange={(e) => setNuovaPassword(e.target.value)}
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 flex-1"
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={(el) => (inputRefs.current[1] = el)}
                        />
                        <button
                            type="button"
                            onClick={() => setIsNuovaPasswordVisible(!isNuovaPasswordVisible)}
                            className="absolute right-2 text-black dark:text-white"
                        >
                            {isNuovaPasswordVisible ? (
                                <EyeClosed size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </div>
                </div>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start">Conferma password: </p>
                    <div className="relative flex items-center ">
                        <input
                            type={isConfermaPasswordVisible ? "text" : "password"}
                            placeholder=""
                            value={confermaPassword}
                            onChange={(e) => setConfermaPassword(e.target.value)}
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 flex-1"
                        />
                        <button
                            type="button"
                            onClick={() => setIsConfermaPasswordVisible(!isConfermaPasswordVisible)}
                            className="absolute right-2 text-black dark:text-white"
                        >
                            {isConfermaPasswordVisible ? (
                                <EyeClosed size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div className='mt-3 grid grid-cols-2'>
                <button
                    onClick={closeModal}
                    className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                >
                    Annulla
                </button>
                <button
                    onClick={handleConferma}
                    className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                >
                    Conferma
                </button>
            </div>
        </div>
    );
};

const ProfiloUtente = () => {
    const [isChangePassowrd, setIsChangePassword] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [nome, setNome] = useState(infoUtente['Nome']);
    const [cognome, setCognome] = useState(infoUtente['Cognome']);
    const [email, setEmail] = useState(infoUtente['Email']);
    const inputRefs = useRef([]);

    const handleAnnulla = () => {
        setNome(infoUtente['Nome']);
        setCognome(infoUtente['Cognome']);
        setEmail(infoUtente['Email']);
        setIsEditing(false);
    };

    const checkEmail = async () => {
        if (email === "" || email === infoUtente["Email"]) return;
        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                alert(data['error']);
                setEmail(infoUtente['Email']);
            }
        } catch (error) {
            alert('Errore nel controllo della mail, riprovare più tardi.');
            console.log(error);
        }

    };

    const handleConferma = async () => {
        try {
            isLoading = true;
            const response = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente['ID'], Nome: nome, Cognome: cognome, Email: email })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
            }
            else {
                isLoading = false;
                setIsEditing(false);
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'operazione, riprovare più tardi");
            console.log(error);
        }
    };

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        await loadFooter();
    };

    const handleChangePassword = () => {
        setIsChangePassword(true);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="PROFILO" />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                <div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Nome: </p>
                        {
                            isEditing ? (
                                <input 
                                type="text" 
                                value={nome} 
                                onChange={(e) => setNome(e.target.value)} 
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" 
                                onKeyDown={(e) => handleKeyDown(e, 0)}
                                ref={(el) => (inputRefs.current[0] = el)}
                                />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{nome}</p>
                            )
                        }
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Cognome: </p>
                        {
                            isEditing ? (
                                <input 
                                type="text" 
                                value={cognome} 
                                onChange={(e) => setCognome(e.target.value)} 
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" 
                                onKeyDown={(e) => handleKeyDown(e, 1)}
                                ref={(el) => (inputRefs.current[1] = el)}
                                />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{cognome}</p>
                            )
                        }
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Email: </p>
                        {
                            isEditing ? (
                                <input 
                                type="text" 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                onBlur={checkEmail} 
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" 
                                onKeyDown={(e) => handleKeyDown(e, 2)}
                                ref={(el) => (inputRefs.current[2] = el)}
                                />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{email}</p>
                            )
                        }
                    </div>
                    <div className='grid grid-cols-2'>
                        {
                            isEditing ? (
                                <>
                                    <button
                                        onClick={handleAnnulla}
                                        className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                                    >
                                        Annulla
                                    </button>
                                    <button
                                        onClick={handleConferma}
                                        className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                                    >
                                        Conferma
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button className="mr-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={() => setIsEditing(true)}>
                                        Modifica Profilo
                                    </button>
                                    <button className="ml-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleChangePassword}>
                                        Cambia Password
                                    </button>
                                </>
                            )
                        }

                    </div>
                </div>
                <ChangePassword isVisible={isChangePassowrd} setIsVisible={setIsChangePassword} />
            </div>
            <FooterUtente />
        </div>
    );
};

export default ProfiloUtente;